module.exports = __webpack_public_path__ + "img/Artboard 3.db43f70c.jpg";